export enum Breadcrumbs {
  Footer = 'footer',
  Navigation = 'navigation',
  NavigationLinks = 'navigation-links',
}
